import { LabelValue } from '~/components/component-library/LabelValue'
import { renderValue } from '~/components/txn-display/properties/renderValue'
import { cn } from '~/utils/tailwind-utils'

type PropertyRowProps = {
  label: string
  value: unknown
  listIndex: number
}

export const PropertyRow = ({ label, value, listIndex }: PropertyRowProps) => {
  const rendered = renderValue(value)

  return (
    <LabelValue
      label={label}
      listIndex={listIndex}
      size="small"
      value={
        <span
          className={cn('truncate', {
            italic: rendered.variant === 'null',
            'font-mono': rendered.variant === 'json',
            'tabular-nums': rendered.variant === 'number',
          })}
          title={rendered.title}
        >
          {rendered.display}
        </span>
      }
    />
  )
}
